export enum InvoiceDeliveryMethodStringEnum {
  AutoGiro = 'autogiro',
  Card = 'card', // Medlemskort
  EBrev = 'e-brev', // Brev
  File = 'file', // Brev
  Email = 'mail', // Mejl
  Unknown = 'okänt', // Brev
  Print = 'print', // Brev
  SMS = 'sms', // SMS
  Letter = 'letter', // Brev
  Kivra = 'kivra',
}

export const getInvoiceDeliveryMethodStringText = (type: InvoiceDeliveryMethodStringEnum, t: (n: string) => string): string => {
  return t(`invoice:invoiceDeliveryMethodString.${type}`) || t('invoice:invoiceDeliveryMethodString.unknown');
};
